// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import { PartyPopper, Truck, HardHat, Wrench } from "lucide-react";

export const MOCK_DATA = [
  {
    id: 1,
    date: "2025-05-02",
    type: "event",
    title: "Frühjahrsmarkt",
    org: "Stadtmarkt GmbH",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "08:00–18:00",
    status: "confirmed",
    ref: "VHP-2025-001",
    tenant: "stadtplatz",
  },
  {
    id: 2,
    date: "2025-05-03",
    type: "event",
    title: "Frühjahrsmarkt (Tag 2)",
    org: "Stadtmarkt GmbH",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "08:00–18:00",
    status: "confirmed",
    ref: "VHP-2025-001",
    tenant: "stadtplatz",
  },
  {
    id: 3,
    date: "2025-05-07",
    type: "delivery",
    title: "DHL Lieferzone",
    org: "DHL Express",
    source: "booking",
    location: "hardenberg",
    scenario: "delivery",
    time: "06:00–10:00",
    status: "confirmed",
    ref: "VHP-2025-002",
    tenant: "stadtplatz",
  },
  {
    id: 4,
    date: "2025-05-12",
    type: "construction",
    title: "Straßenbauarbeiten A100",
    org: "Berliner Senat",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "07:00–17:00",
    status: "confirmed",
    ref: "SEAS-20250512",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Straßenereignis #A100-12",
  },
  {
    id: 5,
    date: "2025-05-13",
    type: "construction",
    title: "Straßenbauarbeiten A100",
    org: "Berliner Senat",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "07:00–17:00",
    status: "confirmed",
    ref: "SEAS-20250513",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Straßenereignis #A100-12",
  },
  {
    id: 6,
    date: "2025-05-14",
    type: "construction",
    title: "Straßenbauarbeiten A100",
    org: "Berliner Senat",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "07:00–17:00",
    status: "confirmed",
    ref: "SEAS-20250514",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Straßenereignis #A100-12",
  },
  {
    id: 7,
    date: "2025-05-19",
    type: "event",
    title: "Kulturfestival Berlin",
    org: "Kulturamt Berlin",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "10:00–22:00",
    status: "confirmed",
    ref: "VHP-2025-007",
    tenant: "bezirksamt",
  },
  {
    id: 8,
    date: "2025-05-20",
    type: "event",
    title: "Kulturfestival Berlin",
    org: "Kulturamt Berlin",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "10:00–22:00",
    status: "confirmed",
    ref: "VHP-2025-007",
    tenant: "bezirksamt",
  },
  {
    id: 9,
    date: "2025-05-21",
    type: "event",
    title: "Kulturfestival Berlin",
    org: "Kulturamt Berlin",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "10:00–22:00",
    status: "confirmed",
    ref: "VHP-2025-007",
    tenant: "bezirksamt",
  },
  {
    id: 10,
    date: "2025-05-26",
    type: "infra",
    title: "Leitungsarbeiten Gas",
    org: "GASAG Berlin",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "Ganztägig",
    status: "confirmed",
    ref: "SEAS-20250526",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Infrastrukturmaßnahme #G-889",
  },
  {
    id: 11,
    date: "2025-05-28",
    type: "delivery",
    title: "Rewe Lieferfenster",
    org: "Rewe Logistik",
    source: "booking",
    location: "hardenberg",
    scenario: "delivery",
    time: "06:30–08:30",
    status: "confirmed",
    ref: "VHP-2025-011",
    tenant: "vhptest",
  },
  {
    id: 12,
    date: "2025-06-04",
    type: "event",
    title: "Sommerfest Charlottenburg",
    org: "Bezirksamt",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "12:00–22:00",
    status: "confirmed",
    ref: "VHP-2025-015",
    tenant: "bezirksamt",
  },
  {
    id: 13,
    date: "2025-06-05",
    type: "event",
    title: "Sommerfest Charlottenburg",
    org: "Bezirksamt",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "12:00–22:00",
    status: "confirmed",
    ref: "VHP-2025-015",
    tenant: "bezirksamt",
  },
  {
    id: 14,
    date: "2025-06-06",
    type: "event",
    title: "Sommerfest Charlottenburg",
    org: "Bezirksamt",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "12:00–22:00",
    status: "confirmed",
    ref: "VHP-2025-015",
    tenant: "bezirksamt",
  },
  {
    id: 15,
    date: "2025-06-10",
    type: "infra",
    title: "Glasfaserausbau",
    org: "Deutsche Telekom",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "08:00–16:00",
    status: "confirmed",
    ref: "SEAS-20250610",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Infrastrukturmaßnahme #T-221",
  },
  {
    id: 16,
    date: "2025-06-11",
    type: "infra",
    title: "Glasfaserausbau",
    org: "Deutsche Telekom",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "08:00–16:00",
    status: "confirmed",
    ref: "SEAS-20250611",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Infrastrukturmaßnahme #T-221",
  },
  {
    id: 17,
    date: "2025-06-18",
    type: "delivery",
    title: "Metro Großlieferung",
    org: "Metro AG",
    source: "booking",
    location: "hardenberg",
    scenario: "delivery",
    time: "05:00–09:00",
    status: "confirmed",
    ref: "VHP-2025-020",
    tenant: "vhptest",
  },
  {
    id: 18,
    date: "2025-06-25",
    type: "construction",
    title: "Kanalsanierung",
    org: "BWB Berlin",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "Ganztägig",
    status: "confirmed",
    ref: "SEAS-20250625",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Kanalbaumaßnahme #BWB-77",
  },
  {
    id: 19,
    date: "2025-06-26",
    type: "construction",
    title: "Kanalsanierung",
    org: "BWB Berlin",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "Ganztägig",
    status: "confirmed",
    ref: "SEAS-20250626",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Kanalbaumaßnahme #BWB-77",
  },
  {
    id: 20,
    date: "2025-07-04",
    type: "event",
    title: "Stadtfest Berlin",
    org: "Berlin Tourismus",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "10:00–23:00",
    status: "confirmed",
    ref: "VHP-2025-025",
    tenant: "bezirksamt",
  },
  {
    id: 21,
    date: "2025-07-05",
    type: "event",
    title: "Stadtfest Berlin",
    org: "Berlin Tourismus",
    source: "booking",
    location: "hardenberg",
    scenario: "market",
    time: "10:00–23:00",
    status: "confirmed",
    ref: "VHP-2025-025",
    tenant: "bezirksamt",
  },
  {
    id: 22,
    date: "2025-07-14",
    type: "delivery",
    title: "Amazon Lieferfläche",
    org: "Amazon Logistics",
    source: "booking",
    location: "hardenberg",
    scenario: "delivery",
    time: "06:00–11:00",
    status: "confirmed",
    ref: "VHP-2025-028",
    tenant: "vhptest",
  },
  {
    id: 23,
    date: "2025-07-21",
    type: "infra",
    title: "Straßenbeleuchtung Erneuerung",
    org: "Stromnetz Berlin",
    source: "seas",
    location: "hardenberg",
    scenario: "all",
    time: "09:00–15:00",
    status: "confirmed",
    ref: "SEAS-20250721",
    tenant: "stadtplatz",
    seasNote: "Berliner Open Data · Infrastrukturmaßnahme #SNB-445",
  },
];

export const TYPE_KEYS = ["event", "delivery", "construction", "infra"];

export const TYPE_CONFIG = {
  event: {
    label: "Veranstaltung",
    Icon: PartyPopper,
    bg: "var(--av-event-bg)",
    border: "var(--av-event-border)",
    text: "var(--av-event-text)",
  },
  delivery: {
    label: "Lieferung",
    Icon: Truck,
    bg: "var(--av-delivery-bg)",
    border: "var(--av-delivery-border)",
    text: "var(--av-delivery-text)",
  },
  construction: {
    label: "Baustelle",
    Icon: HardHat,
    bg: "var(--av-construction-bg)",
    border: "var(--av-construction-border)",
    text: "var(--av-construction-text)",
  },
  infra: {
    label: "Infrastruktur",
    Icon: Wrench,
    bg: "var(--av-infra-bg)",
    border: "var(--av-infra-border)",
    text: "var(--av-infra-text)",
  },
};

export const TENANT_OPTIONS = [
  { value: "all", label: "Alle Mandanten" },
  { value: "stadtplatz", label: "Stadtplatz Berlin" },
  { value: "bezirksamt", label: "Bezirksamt Charlottenburg" },
  { value: "vhptest", label: "VHP Test" },
];

export const LOCATION_LABELS = {
  all: "Alle Standorte",
  hardenberg: "Hardenbergplatz Berlin",
  alexanderplatz: "Alexanderplatz",
  potsdamer: "Potsdamer Platz",
};

export const SCENARIO_LABELS = {
  all: "Alle Szenarien",
  market: "Markt",
  delivery: "Lieferfläche",
  parking: "Parkfläche",
};

export const FILTER_SUMMARY_DEFAULT =
  "Hardenbergplatz Berlin · Alle Szenarien · Mai – Aug 2025";

export const STAT_ENTRIES = [
  { key: "total", label: "Gesamt", sub: "Tage", colorVar: "--av-text" },
  {
    key: "event",
    label: "Veranstaltung",
    sub: "Tage",
    colorVar: "--av-event-border",
  },
  {
    key: "delivery",
    label: "Lieferung",
    sub: "Tage",
    colorVar: "--av-delivery-border",
  },
  {
    key: "construction",
    label: "Baustelle",
    sub: "Tage (SEAS)",
    colorVar: "--av-construction-border",
  },
  {
    key: "infra",
    label: "Infra",
    sub: "Tage (SEAS)",
    colorVar: "--av-infra-border",
  },
  {
    key: "seas",
    label: "SEAS-Quelle",
    sub: "von {total}",
    colorVar: "--av-construction-border",
  },
];
